module.exports = __webpack_public_path__ + "tables/media/messages-filled.043357f7.svg";